import { Component, OnInit, isDevMode, Input } from '@angular/core'
import {
  IProductListing,
  MarketService,
} from '../../../services/market.service'
import { ProductService } from '../../../services/product.service'

import { AuthenticationService } from '../../../services/authentication.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'app-product-related-item',
  templateUrl: './product-related-item.component.html',
  styleUrls: ['./product-related-item.component.scss'],
})
export class ProductRelatedItemComponent implements OnInit {
  recommendations: IProductListing[] = []
  isReseller: Observable<boolean>

  @Input() white_bg = false

  constructor(
    private market: MarketService,
    private productService: ProductService,
    authenticationService: AuthenticationService
  ) {
    this.isReseller = authenticationService.isReseller
  }

  ngOnInit() {
    this.market.recommendations(0).subscribe(
      (result) => {
        this.recommendations = result
      },
      (error) => {
        if (isDevMode) {
          // eslint-disable-next-line no-console
          console.error('failed to load recommendations', error)
        }
      }
    )
  }

  url(product: IProductListing) {
    return ['/'].concat(this.productService.urlAbsoluteRoute(product))
  }
}
